import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import MissionControlHeader from './mission_control_header';
import GenericModal from '../../containers/modal/generic_modal';
import {BUTTON_STYLE, BUTTON_COLOR, TIERS} from '../../constants';
import Button from '../../forecast-app/shared/components/buttons/button/button';
import Dropdown from '../../forecast-app/shared/components/dropdowns/dropdown';
import Checkbox from '../../components/new-ui/check_box';
import UpdateFeatureFlag from '../../mutations/mission_control/feature_flag_mutation';
import Util from '../../forecast-app/shared/util/util';
import Toggle from '../../components/inputs/toggle';

class featureFlags extends Component {
	constructor(props) {
		super(props);

		this.state = {
			collapsed: [],
			deleteClickedForId: null,
			showAddCustomer: false,
			showEditCustomer: false,
			customerData: null,
			allPersonsByCompany: {},
			allCompanies: [],
			showPersons: [],
			selectedPersons: [],
			selectedCustomer: null,
			selectAllPersons: false,
			currentFeature: null,
			team: 'ALL',
			availableFeatureFlags: this.props.viewer.availableFeatureFlags.map(flag => flag.key),
			loadingFlagChange: false,
		};
	}

	componentDidMount() {
		const allPersonsByCompany = {};
		const allCompanies = [];
		const activeCompanyIds = [];
		this.props.viewer.missionControlData.companies.forEach(company => {
			const contactEmail = company.contactEmail || ''; //can be null
			if (!company.accessBlocked && company.tier !== TIERS.TRIAL && !contactEmail.includes('@forecast')) {
				activeCompanyIds.push(btoa(`CompanyType:${company.companyId}`));
			}
		});

		this.props.viewer.missionControlData.otherPersons.forEach(p => {
			if (allPersonsByCompany[p.companyId]) {
				const persons = allPersonsByCompany[p.companyId];
				persons.push(p);
				allPersonsByCompany[p.companyId] = persons;
			} else {
				const isActive = activeCompanyIds.includes(p.companyId);
				const x = {value: p.companyId, label: p.companyName + (isActive ? ' (active)' : ''), active: isActive};
				allCompanies.push(x);
				allPersonsByCompany[p.companyId] = [p];
			}
		});

		const collapsed = this.props.viewer.missionControlData.availableFeatures.map(f => {
			return f.key;
		});

		let team = Util.localStorageGetItem('missin-control-featture-flag-team');
		if (!team) {
			team = 'ALL';
		}
		this.setState({allPersonsByCompany, allCompanies, collapsed, team});
	}

	handleTeam(e) {
		const team = e.value;
		Util.localStorageSetItem('missin-control-featture-flag-team', team);
		this.setState({team});
		return;
	}

	editCustomer(data, key, name) {
		const specificPersons = data.specificUsers.map(p => p.id);
		const personOptions = this.state.allPersonsByCompany[data.id].filter(p => !specificPersons.includes(p.id));
		this.setState({
			showEditCustomer: true,
			customerData: data,
			selectAllPersons: data.allUsers,
			selectedCustomer: data.id,
			selectedPersons: specificPersons,
			showPersons: personOptions.map(p => {
				return {value: p.id, label: this.getName(p)};
			}),
			currentFeature: {key, name},
		});
	}

	showAddCustomer(key, name) {
		this.setState({showAddCustomer: true, currentFeature: {key, name}});
	}

	getUsers(data) {
		const rrr = (
			<div>
				{data.specificUsers.map(s => {
					return <div>{this.getNameV2(s)}</div>;
				})}
			</div>
		);
		return rrr;
	}

	getCompany(data, key, name) {
		return (
			<tr key={data.id} className="feature-flag-group">
				<td>{data.name}</td>
				<td>{data.allUsers ? 'All users' : this.getUsers(data)}</td>
				<td>
					<div className="edit-company-container">
						<div className="edit-company" onClick={this.editCustomer.bind(this, data, key, name)} />
					</div>
				</td>
			</tr>
		);
	}

	toggleActivities(key) {
		if (this.state.collapsed.some(c => c === key)) {
			this.setState({collapsed: this.state.collapsed.filter(c => c !== key)});
		} else {
			this.setState({collapsed: [...this.state.collapsed, key]});
		}
	}

	getFeatureFlag(data, key, name, color) {
		const values = Object.values(data[key]);

		let content;
		if (values && values.length > 0) {
			content = (
				<div>
					<table className="feature-flag-group-table">
						<thead>
							<tr>
								<th className="feature-flag-group-table-width">Company</th>
								<th className="feature-flag-group-table-width">Users</th>
							</tr>
						</thead>
						<tbody>{values.map(d => this.getCompany(d, key, name))}</tbody>
					</table>
				</div>
			);
		} else {
			content = <h3 id={data.name}>No one has access to this feature yet.</h3>;
		}
		const collapsed = this.state.collapsed.some(c => c === key);
		return (
			<div key={key} className="feature-flag-group" style={{backgroundColor: color}}>
				<div className="new-company-container">
					<h2>{name}</h2>
					<div className="new-company" onClick={this.showAddCustomer.bind(this, key, name)} />
					<div onClick={this.toggleActivities.bind(this, key)} className={'arrow' + (collapsed ? '' : ' expanded')} />
					<div style={{paddingLeft: '20px'}}>Companies: {values.filter(v => v.allUsers).length}</div>
					<div style={{paddingLeft: '20px'}}>Individual users: {values.filter(v => !v.allUsers).reduce((prev, current) => current.specificUsers.length + prev, 0)}</div>
					<div style={{margin: '0 30px 0 auto'}}>
						<span>Active for your company: </span>
						<Toggle checked={this.state.availableFeatureFlags.includes(key)} onChange={!this.state.loadingFlagChange ? this.toggleFeatureFlag.bind(this, key) : () => null} />
					</div>
				</div>
				{!collapsed && content}
			</div>
		);
	}

	setPersonsToShow(value) {
		this.setState({
			showPersons: this.state.allPersonsByCompany[value.value].map(p => {
				return {value: p.id, label: this.getName(p)};
			}),
			selectedCustomer: value.value,
		});
	}

	getName(person) {
		return person.firstName + (person.lastName ? ' ' + person.lastName : '') + (person.email ? ' (' + person.email + ')' : '');
	}

	getNameV2(person) {
		return person.name + (person.email ? ' (' + person.email + ')' : '');
	}

	setSelectedPerson(person) {
		const selectedPersons = this.state.selectedPersons;
		selectedPersons.push(person.value);

		const updatedShowPersons = this.state.showPersons.filter(p => !selectedPersons.includes(p.value));

		this.setState({selectedPersons, showPersons: updatedShowPersons});
	}

	closeModal() {
		this.setState({currentFeature: null, showAddCustomer: false, showEditCustomer: false, selectAllPersons: false, selectedCustomer: null, selectedPersons: [], showPersons: []});
	}

	saveNewCustomerAccess() {
		if (this.state.selectAllPersons) {
			Util.CommitMutation(UpdateFeatureFlag, {
				featureFlag: this.state.currentFeature.key,
				companyId: this.state.selectedCustomer,
				allUsers: true,
			});
		} else if (this.state.selectedPersons.length > 0) {
			Util.CommitMutation(UpdateFeatureFlag, {
				featureFlag: this.state.currentFeature.key,
				companyId: this.state.selectedCustomer,
				persons: this.state.selectedPersons,
			});
		} else {
			this.removeCustomerAccess();
		}
	}

	toggleFeatureFlag(key) {
		this.setState({loadingFlagChange: true});
		if (this.state.availableFeatureFlags.includes(key)) {
			const onSuccess = () => {
				const featureFlags = this.state.availableFeatureFlags;
				featureFlags.splice(featureFlags.indexOf(key), 1);
				this.setState({availableFeatureFlags: featureFlags, loadingFlagChange: false});
			};
			Util.CommitMutation(
				UpdateFeatureFlag,
				{
					featureFlag: key,
					companyId: this.props.viewer.company.id,
					removeAccess: true,
				},
				onSuccess
			);
		} else {
			const onSuccess = () => {
				const featureFlags = this.state.availableFeatureFlags;
				featureFlags.push(key);
				this.setState({availableFeatureFlags: featureFlags, loadingFlagChange: false});
			};
			Util.CommitMutation(
				UpdateFeatureFlag,
				{
					featureFlag: key,
					companyId: this.props.viewer.company.id,
					allUsers: true,
				},
				onSuccess
			);
		}
	}

	addTenRandom(filteredCustomers) {
		const shuffled = filteredCustomers.sort(() => 0.5 - Math.random());
		const selected = shuffled.slice(0, 10);
		selected.forEach(c => {
			Util.CommitMutation(UpdateFeatureFlag, {
				featureFlag: this.state.currentFeature.key,
				companyId: c.value,
				allUsers: true,
			});
		});
	}

	removeCustomerAccess() {
		Util.CommitMutation(UpdateFeatureFlag, {
			featureFlag: this.state.currentFeature.key,
			companyId: this.state.selectedCustomer,
			removeAccess: true,
		});
		this.setState({showAddCustomer: false, showEditCustomer: false, selectAllPersons: false, selectedCustomer: null, selectedPersons: [], showPersons: []});
	}

	removeCustomer(person) {
		let selectedPersons = this.state.selectedPersons;

		selectedPersons = selectedPersons.filter(p => p !== person.id);

		const showPersons = this.state.showPersons;
		showPersons.push({value: person.id, label: this.getName(person)});
		this.setState({selectedPersons, showPersons});
	}

	getAddCustomerModal(data) {
		const values = Object.values(data[this.state.currentFeature.key]);
		const filteredCustomers = this.state.allCompanies.filter(c => {
			return !values.find(d => d.id === c.value);
		});

		const content = (
			<div className="feature-flag-modal">
				<Dropdown
					options={this.state.showAddCustomer ? filteredCustomers : this.state.allCompanies}
					onChange={this.setPersonsToShow.bind(this)}
					value={this.state.selectedCustomer}
					multi={false}
					disabled={this.state.showEditCustomer}
					label={'Select customer'}
					clearable={true}
				/>
				<div className={'description'}>Active means: not trial and not Forecast and not blocked</div>
				<div className="feature-flag-users-to-add-all-group">
					<div className="feature-flag-users-to-add-all-title">Select all users</div>
					<div className="feature-flag-users-to-add-all">
						<Checkbox
							onChange={() => {
								this.setState({selectAllPersons: !this.state.selectAllPersons});
							}}
							isChecked={this.state.selectAllPersons}
							isDisabled={!this.state.selectedCustomer}
						/>
					</div>
				</div>
				<Dropdown options={this.state.showPersons} onChange={this.setSelectedPerson.bind(this)} value={null} multi={true} label={'Select users'} clearable={true} disabled={this.state.selectAllPersons || !this.state.selectedCustomer} />

				{!this.state.selectAllPersons && this.state.selectedPersons && this.state.selectedPersons.length > 0 ? <div className="feature-flag-users-to-add-title">Users that will be added:</div> : null}
				{!this.state.selectAllPersons
					? this.state.selectedPersons.map(p => {
							const person = this.state.allPersonsByCompany[this.state.selectedCustomer].find(pp => pp.id === p);
							return (
								<div className="feature-flag-user-container">
									<div className="feature-flag-users-to-add">- {person ? this.getName(person) : p}</div>
									<div className="feature-flag-remove-user" onClick={this.removeCustomer.bind(this, person)} />
								</div>
							);
					  })
					: null}
				{this.state.selectAllPersons ? <div className="feature-flag-users-to-add-title">All users in company will get access!</div> : null}
			</div>
		);
		const buttons = [
			{
				text: 'Add 10 random',
				style: BUTTON_STYLE.FILLED,
				color: BUTTON_COLOR.PURPLE,
				callback: this.addTenRandom.bind(this, filteredCustomers),
				disabled: !filteredCustomers || filteredCustomers.length === 0,
			},
			{
				text: 'Cancel',
				style: BUTTON_STYLE.FILLED,
				color: BUTTON_COLOR.WHITE,
			},
			{
				text: 'Save',
				style: BUTTON_STYLE.FILLED,
				color: BUTTON_COLOR.GREEN,
				callback: this.saveNewCustomerAccess.bind(this),
			},
		];
		if (this.state.showEditCustomer) {
			const remove = {
				text: 'Remove feature access',
				style: BUTTON_STYLE.FILLED,
				color: BUTTON_COLOR.RED,
				callback: this.removeCustomerAccess.bind(this),
			};
			buttons.unshift(remove);
		}
		return <GenericModal closeModal={() => this.closeModal()} buttons={buttons} content={content} headerText={this.state.currentFeature.name} />;
	}

	collapseExpandAll() {
		if (this.state.collapsed.length > 0) {
			this.setState({collapsed: []});
		} else {
			this.setState({collapsed: this.props.viewer.missionControlData.availableFeatures.map(f => f.key)});
		}
	}

	handleTea32323m(e) {
		const team = e.value;
		Util.localStorageSetItem('missin-control-featture-flag-team', team);
		this.setState({team});
	}

	render() {
		const allTeams = [
			{value: 'ALL', label: 'All'},
			{value: 'WORK_IN_PROGRESS', label: 'Team - Work In Progress'},
			{value: 'LAST_CALL', label: 'Last Call Legacy'},
			{value: 'GEEK_SQUAD', label: 'Geek Squad'},
			{value: 'INTELLIGENCE', label: 'Intelligence'},
		];

		if (!this.props.viewer.missionControlData) {
			this.props.history.push('/not-found');
			return null;
		}

		const data = {};
		this.props.viewer.missionControlData.availableFeatures.forEach(f => {
			const c = {};

			f.persons.forEach(p => {
				if (c[p.companyId]) {
					const tmp = c[p.companyId];
					const tmp2 = tmp.specificUsers;
					tmp2.push(p);
					tmp.specificUsers = tmp2;
					tmp.allUsers = false;
					c[p.companyId] = tmp;
				} else {
					c[p.companyId] = {id: p.companyId, name: p.companyName, allUsers: false, specificUsers: [p]};
				}
			});

			f.companies.forEach(cc => {
				c[cc.id] = {id: cc.id, name: cc.name, allUsers: true, specificUsers: []};
			});

			data[f.key] = c;
		});

		return (
			<div className="mission-control-features">
				<MissionControlHeader viewer={this.props.viewer} />
				<div className="mission-control-features-header">
					<h1>Feature flags</h1>
					<Button style={{margin: 125}} text={'Collapse / expand all'} buttonStyle={BUTTON_STYLE.FILLED} colorTheme={BUTTON_COLOR.WHITE} onClick={this.collapseExpandAll.bind(this)} />
					<div className="team-dropdown" spellcheck="false">
						<Dropdown focusOnClick={true} optionClickEvent={true} onChange={this.handleTeam.bind(this)} options={allTeams} value={this.state.team} hideLabel={true} disabled={false} />
					</div>
				</div>
				{this.state.showAddCustomer || this.state.showEditCustomer ? this.getAddCustomerModal(data) : null}
				<div className="mission-control-list-features">
					{this.props.viewer.missionControlData.availableFeatures
						.filter(f => {
							if (this.state.team !== '' && this.state.team !== 'ALL') {
								return this.state.team === f.team;
							} else {
								return true;
							}
						})
						.map(f => {
							return this.getFeatureFlag(data, f.key, f.name, f.color);
						})}
				</div>
			</div>
		);
	}
}

const featureFlagsQuery = graphql`
	query featureFlags_Query {
		viewer {
			actualPersonId
			component(name: "control_feature_flags")
			...featureFlags_viewer
		}
	}
`;

export {featureFlagsQuery};

export default createFragmentContainer(withRouter(featureFlags), {
	viewer: graphql`
		fragment featureFlags_viewer on Viewer {
			component(name: "control_feature_flags")
			id
			company {
				id
			}
			availableFeatureFlags {
				key
			}
			...missionControlHeader_viewer
			missionControlData {
				id
				companies {
					id
					companyId
					name
					tier
					forecastDemo
					contactEmail
					accessBlocked
				}
				availableFeatures {
					id
					name
					key
					color
					team
					companies {
						id
						name
					}
					persons {
						id
						companyId
						companyName
						name
						email
					}
				}
				otherPersons(includeForecastPersons: true) {
					id
					firstName
					lastName
					email
					companyName
					companyId
				}
			}
		}
	`,
});
